export default [
  {
    key: 'name',
    label: 'File',
  },
];
